import { createSelector } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, USER_ROLE, USER_ROLE_VALUE } from '~/constants';
import identity from '~/identity';
import { selectFeature, selectUserAccountRole } from '~/selectors';

let selector;

const validateMinRole = (cur) => (target) => USER_ROLE_VALUE[cur] >= USER_ROLE_VALUE[target];

export default createSelector(selectUserAccountRole, identity, (role, state) => {
  selector ??= selectFeature(ACCOUNT_FEATURE.USER_ROLES);
  const [, config] = selector(state);
  const isMinRole = validateMinRole(role);

  return {
    canJoinBroadcast: config.canJoinBroadcast ?? isMinRole(USER_ROLE.GUEST),

    canViewOwnRecordings: config.canViewOwnRecordings ?? isMinRole(USER_ROLE.CONTRIBUTOR),
    canEditOwnVideos: config.canEditOwnVideos ?? isMinRole(USER_ROLE.CONTRIBUTOR),
    canUploadVideo: config.canUploadVideo ?? isMinRole(USER_ROLE.CONTRIBUTOR),
    canRecordVideo: config.canRecordVideo ?? isMinRole(USER_ROLE.CONTRIBUTOR),

    canViewAllRecordings: config.canViewAllRecording ?? isMinRole(USER_ROLE.CREATOR),
    canEditOthersVideos: config.canEditOthersVideos ?? isMinRole(USER_ROLE.CREATOR),
    canNavigateInPortal: config.canNavigateInPortal ?? isMinRole(USER_ROLE.CREATOR),
    canCreateBroadcast: config.canCreateBroadcast ?? isMinRole(USER_ROLE.CREATOR),
    canClipVideo: config.canClipVideo ?? isMinRole(USER_ROLE.CREATOR),
    canDeleteVideo: config.canDeleteVideo ?? isMinRole(USER_ROLE.CREATOR),
    canDownloadVideo: config.canDownloadVideo ?? isMinRole(USER_ROLE.CREATOR),
    canPublishVideo: config.canPublishVideo ?? isMinRole(USER_ROLE.CREATOR),
    canRecordInStudio: config.canRecordInStudio ?? isMinRole(USER_ROLE.CREATOR),

    canInviteUserToStudio: config.canInviteUserToStudio ?? isMinRole(USER_ROLE.PRODUCER),

    canBroadcastLive: config.canBroadcastLive ?? isMinRole(USER_ROLE.BROADCASTER),

    canManageUsers: config.canManageUsers ?? isMinRole(USER_ROLE.ADMIN),
    canManagePlayers: config.canManagePlayers ?? isMinRole(USER_ROLE.ADMIN),
    canManageChannels: config.canManageChannels ?? isMinRole(USER_ROLE.ADMIN),
    canManageIntegrations: config.canManageIntegrations ?? isMinRole(USER_ROLE.ADMIN),
    canManageSubscriptions: config.canManageSubscriptions ?? isMinRole(USER_ROLE.ADMIN),
  };
});
